import React, { useMemo } from 'react';
import { FlagType } from '../../../../../../@types/product.enum';
import { useFlags } from '../../providers/FlagsProvider';
import { InfoIcon } from '../../../../../styled/Icon';
import Distance from '../../../../../styled/Distance';
import Box from '../../../../../styled/Box';
import { Columns } from '../../../../../styled/Columns/wrappers';
import { Column } from '../../../../../styled/Columns/wrappers';

const OutletInformationBox = () => {
  const outletFlag = useFlags(FlagType.outlet);

  const showInformationBox = useMemo(() => outletFlag, [outletFlag]);

  if (!showInformationBox) {
    return null;
  }

  return (
    <div>
      <Distance size="3" />
      <Box background="warning" overhang="mobile" rounded>
        <Columns className="space-2">
          <Column>
            <InfoIcon className="xlarge" />
          </Column>
          <Column>
            <span>
              Outletprodukter är utgående sortiment som du kan köpa i våra fysiska butiker och
              gäller så långt lagret räcker. Kan ej skickas mellan butiker.
            </span>
            <Distance size="half" />
          </Column>
        </Columns>
      </Box>
    </div>
  );
};
export default OutletInformationBox;
